import {EventData} from '@/types/event';
import {Subject} from 'rxjs';

type EventChangeData =
  | {
      type: 'change';
      data: EventData;
    }
  | {
      type: 'new';
      data: EventData;
    }
  | {
      type: 'deleted';
      id: string;
    };

const eventChangeSubject = new Subject<EventChangeData>();

export const eventChangeObservable = eventChangeSubject.asObservable();

export const emitEventChangeEvent = (data: EventChangeData): void => {
  eventChangeSubject.next(data);
};
